import { ADVISOR_NOTE_SEVERITY, ADVISOR_NOTE_STATUS } from "./constants";

// A warning confirmed before auto-forwarding was steered without a `steered`
// flag: the old decision path only moved the status.
export function advisorNoteWasDelivered(note: {
  severity?: unknown;
  status?: unknown;
  steered?: unknown;
}): boolean {
  return (
    note.steered === true ||
    (note.severity === ADVISOR_NOTE_SEVERITY.WARN &&
      note.status === ADVISOR_NOTE_STATUS.CONFIRMED)
  );
}
